import React from 'react';
export const DownloadButton = React.forwardRef(() => {
    return null;
});
//# sourceMappingURL=DownloadButton.js.map